<!-- Editor -->
<div #view class="view document-editor" (scroll)="onScroll($event)">

  <!-- Module -->
  <ng-container *ngFor="let module of moduleService.module$ | async | pveFilter">
    <div *ngIf="module.active && !module.hide" class="module" [id]="module._id">
      <div class="wrapper">
        <sg2-module-options 
          *ngIf="authService.canRead('element-contextmenu'); else spacer"
          class="options"
          [module]="module" 
          [options]="['addSubmodule', 'assignTo', 'delete', 'setStatus']">
        </sg2-module-options>
        <h1>
          <span>{{ module.chapter }}.&nbsp;</span>
          <span [attr.contenteditable]="authService.canUpdate('module')"
            (keydown.enter)="submitTitle($event, 'module', module)"
            (blur)="submitTitle($event, 'module', module)">{{ module.name }}
          </span>
        </h1>
      </div>
    
      <!-- Submodule -->
      <ng-container *ngFor="let submodule of module.submodules" >
        <div *ngIf="submodule.active" class="submodule" [id]="submodule._id">

          <div class="wrapper">
            <sg2-submodule-options 
              *ngIf="authService.canRead('element-contextmenu'); else spacer"
              class="options"
              [submodule]="submodule" 
              [options]="['addElement', 'assignTo', 'delete', 'setStatus']">
            </sg2-submodule-options>
            <h2 [class.muted]="!submodule.chapter">
              <span *ngIf="submodule.chapter">{{ submodule.chapter }}.&nbsp;</span>
              <span [attr.contenteditable]="authService.canUpdate('submodule')"
                (keydown.enter)="submitTitle($event, 'submodule', submodule)"
                (blur)="submitTitle($event, 'submodule', submodule)">{{ submodule.name }}
              </span>
            </h2>
          </div>
    
          <!-- Element -->
          <ng-container *ngFor="let element of submodule.elements">
            <div *ngIf="element.active" class="element">
              <sg2-project-info-element [element]="element"></sg2-project-info-element>
            </div>
          </ng-container>

        </div>
      </ng-container>
    </div>
  </ng-container>
</div>

<!-- Spacer for context menu -->
<ng-template #spacer><span></span></ng-template>
